<script>
import PackageProdBody from './package-prod-components'
export default {
  name: 'PackageCRABody',
  components: { PackageProdBody },
  props: {
    componentDataObject: {
      type: Array,
      default() {
        return []
      },
    },
    fraudPlusPackageDetails: {
      type: Array,
      default() {
        return []
      },
    },
    disabledSection: {
      type: Boolean,
      default: false,
    },
    selectedsections: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      fraudPlusCRAsData: [],
    }
  },
  computed: {},
  mounted() {
    this.fraudPlusCRAsData = this.fraudPlusPackageDetails
      .filter(function(i, n) {
        return i.checked === true
      })
      .map(function(p, q) {
        return p.indexValue
      })
  },
  methods: {
    onChangeCRAs(evt) {
      this.fraudPlusPackageDetails
        .filter((x) => evt.includes(x.indexValue))
        .forEach(function(item) {
          item.checked = true
        })
      this.fraudPlusPackageDetails
        .filter((x) => !evt.includes(x.indexValue))
        .forEach(function(craitem) {
          craitem.checked = false
          craitem.fraudPlusProducts.filter(function(item, index) {
            item.checked = false
            item.fraudPlusProductAddOns.filter(function(additem, index) {
              additem.checked = false
            })
          })
        })

      // let that = this
      // for (let inx = 0; inx < that.fraudPlusPackageDetails.length; inx++) {
      //   if (evt.indexOf(inx) === -1) {
      //     that.fraudPlusPackageDetails[inx].fraudPlusProducts.filter(function(
      //       item,
      //       index
      //     ) {
      //       item.checked = false
      //       item.fraudPlusProductAddOns.filter(function(additem, index) {
      //         additem.checked = false
      //       })
      //     })
      //   }
      // }
      this.$emit(
        'updatePackageData',
        this.fraudPlusPackageDetails,
        this.selectedsections
      )
    },
  },
}
</script>

<template>
  <b-card-body>
    <b-form-checkbox-group
      v-model="fraudPlusCRAsData"
      :options="fraudPlusPackageDetails"
      class="mb-3"
      value-field="indexValue"
      text-field="fraudPlusCRAName"
      :disabled="disabledSection"
      size="lg"
      @change="onChangeCRAs"
    ></b-form-checkbox-group>

    <div
      v-for="selectedCRA in fraudPlusCRAsData"
      :key="selectedCRA"
      class="accordion"
      role="tablist"
    >
      <b-card
        v-if="fraudPlusPackageDetails[selectedCRA].fraudPlusProducts.length > 0"
        no-body
        class="mb-1"
      >
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            v-b-toggle="'cra-accordion-' + selectedCRA"
            block
            variant="default"
            class="text-left d-flex"
            :class="$style.nooutline"
          >
            {{ fraudPlusPackageDetails[selectedCRA].fraudPlusCRAName }}
            <strong aria-hidden="true" class="ml-auto">
              <i class="fa fa-angle-up"></i>
              <i class="fa fa-angle-down"></i>
            </strong>
          </b-button>
        </b-card-header>
        <b-collapse
          :id="'cra-accordion-' + selectedCRA"
          :visible="
            fraudPlusPackageDetails[selectedCRA].fraudPlusProducts.length > 0
          "
          role="tabpanel"
        >
          <PackageProdBody
            :fraud-plus-package-details="
              fraudPlusPackageDetails[selectedCRA].fraudPlusProducts
            "
            :disabled-section="disabledSection"
          ></PackageProdBody>
        </b-collapse>
      </b-card>
    </div>
  </b-card-body>
</template>
<style lang="scss" module>
@import '@design';
.nooutline {
  font-weight: bold;
  color: #000 !important;
  outline: none !important;
  box-shadow: none !important;
}
</style>
